module.exports = __webpack_public_path__ + "img/pollola_sisalta4.fb803353.jpg";